import { createApp, h, nextTick } from 'vue';
import AlertModal from '@/components/AlertModal.vue';

let alertInstance = null;
let initPromise = null;

function getAlertInstance() {
  if (alertInstance) return Promise.resolve(alertInstance);
  if (initPromise) return initPromise;

  initPromise = (async () => {
    const container = document.createElement('div');
    document.body.appendChild(container);

    const alertApp = createApp({
      render() {
        return h(AlertModal, { ref: 'alert' });
      }
    });

    const vm = alertApp.mount(container);
    await nextTick();
    alertInstance = vm.$.exposed || vm.$refs.alert;
    return alertInstance;
  })();

  return initPromise;
}

export function useAlert() {
  const alert = async (options) => {
    const instance = await getAlertInstance();
    return instance.show(options);
  };

  return {
    alert,
    success: (title, text) => alert({ icon: 'success', title, text }),
    error: (title, text) => alert({ icon: 'error', title, text }),
    warning: (title, text) => alert({ icon: 'warning', title, text }),
    info: (title, text) => alert({ icon: 'info', title, text })
  };
}

// Export default para uso global como $alert
export default {
  install(app) {
    const { alert, success, error, warning, info } = useAlert();
    
    app.config.globalProperties.$alert = alert;
    app.config.globalProperties.$alertSuccess = success;
    app.config.globalProperties.$alertError = error;
    app.config.globalProperties.$alertWarning = warning;
    app.config.globalProperties.$alertInfo = info;
  }
};
